module.exports = __webpack_public_path__ + "Flag-324.ddf016595e291fab7729290131de5c99.svg";